(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["produktinfo"] && !Shopify.designMode) return;
  try {
    (function(){
  function addWorkdays(d,days){var r=new Date(d.getTime());var a=0;while(a<days){r.setDate(r.getDate()+1);var w=r.getDay();if(w!==0&&w!==6)a++}return r}
  function fmt(d){
    var D=['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
    var M=['Januar','Februar','Maerz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    return D[d.getDay()]+' '+d.getDate()+'. '+M[d.getMonth()];
  }
  function updAvail(el){
    var p=el.closest('.produktinfo');if(!p)return;
    var sd=parseInt(el.dataset.shippingDays||p.dataset.shippingDays||'2',10);
    var ch=parseInt(p.dataset.cutoffHour||'14',10);
    var now=new Date();var base=new Date(now.getTime());
    if(now.getHours()>=ch)base.setDate(base.getDate()+1);
    var w=base.getDay();if(w===0)base.setDate(base.getDate()+1);if(w===6)base.setDate(base.getDate()+2);
    var del=addWorkdays(base,sd);
    var de=el.querySelector('[data-delivery-date]');if(de)de.textContent=fmt(del);
    var ce=el.querySelector('[data-countdown]');
    if(ce){
      var co=new Date(now.getTime());
      co.setHours(ch,0,0,0);
      if(co<=now)co.setDate(co.getDate()+1);
      var diff=Math.max(0,co-now);
      var h=Math.floor(diff/3600000);
      var m=Math.floor((diff%3600000)/60000);
      ce.textContent=h+' Stunden und '+m+' Minuten';
    }
  }
  function initAvail(){
    document.querySelectorAll('[data-availability]').forEach(function(el){
      updAvail(el);
      setInterval(function(){updAvail(el)},1000);
    });
  }
  function initVariants(){
    document.querySelectorAll('[data-pi-variants]').forEach(function(wrap){
      var jsonEl = wrap.parentNode.querySelector('[data-pi-product-json]');
      if (!jsonEl) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch(e){ return; }
      wrap.querySelectorAll('button[data-pi-option-index]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var group = btn.closest('.pi-variant-group');
          group.querySelectorAll('button').forEach(function(b){b.classList.remove('is-selected'); b.classList.remove('pi-variant-card--just-selected');});
          btn.classList.add('is-selected');
          // Pop nur bei aktiver User-Auswahl — Klasse wieder entfernen, damit beim
          // nächsten Re-Render kein Auto-Pop entsteht.
          btn.classList.add('pi-variant-card--just-selected');
          setTimeout(function(){ btn.classList.remove('pi-variant-card--just-selected'); }, 320);
          var selected = [];
          wrap.querySelectorAll('.pi-variant-group').forEach(function(g){
            var sel = g.querySelector('button.is-selected');
            if (sel) selected.push(sel.dataset.piOptionValue);
          });
          var found = variants.find(function(v){
            return v.options.every(function(o,i){return o === selected[i]});
          });
          if (found){
            var url = new URL(window.location.href);
            url.searchParams.set('variant', found.id);
            window.location.href = url.toString();
          }
        });
      });
    });
  }
  function flyAnimation(btn, cart){
    if (!cart) return;
    var btnRect = btn.getBoundingClientRect();
    var cartRect = cart.getBoundingClientRect();
    var flier = document.createElement('div');
    flier.className = 'pi-flier';
    flier.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
    flier.style.left = (btnRect.left + btnRect.width/2 - 16) + 'px';
    flier.style.top = (btnRect.top + btnRect.height/2 - 16) + 'px';
    document.body.appendChild(flier);
    requestAnimationFrame(function(){
      var dx = (cartRect.left + cartRect.width/2) - (btnRect.left + btnRect.width/2);
      var dy = (cartRect.top + cartRect.height/2) - (btnRect.top + btnRect.height/2);
      flier.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.4)';
      flier.style.opacity = '0';
    });
    setTimeout(function(){ flier.remove(); }, 900);
  }
  function initCTA(){
    document.querySelectorAll('[data-pi-form]').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('[data-pi-cta]');
        if (!btn || btn.disabled || btn.hasAttribute('data-pi-unavailable')) return;
        btn.disabled = true;
        var cart = document.querySelector('cart-icon-component, cart-drawer-component, [data-cart-icon], a[href$="/cart"], .header__cart, .cart-icon-link, .header__icon--cart');
        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function(r){
          if (!r.ok) return r.json().then(function(err){ throw err; });
          return r.json();
        })
        .then(function(addData){
          flyAnimation(btn, cart);
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cartData){ return { addData: addData, cartData: cartData }; });
        })
        .then(function(result){
          var evt = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: result.cartData,
              sourceId: 'produktinfo-' + (form.id || 'block'),
              data: {
                didError: false,
                source: 'product-form',
                productId: result.addData.product_id,
                variantId: result.addData.variant_id,
                itemCount: result.cartData.item_count
              }
            }
          });
          document.dispatchEvent(evt);
          setTimeout(function(){ btn.disabled = false; }, 400);
        })
        .catch(function(err){
          console.error('Produktinfo: Add-to-Cart fehlgeschlagen', err);
          btn.disabled = false;
          alert((err && err.description) || 'Hinzufuegen zum Warenkorb fehlgeschlagen. Bitte erneut versuchen.');
        });
      });
    });
  }
  function init(){ initAvail(); initVariants(); initCTA(); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
  } catch(e) { console.error(e); }
})();

})();
